import { ar, de, fr } from 'date-fns/locale';
import { formatDistanceToNow } from 'date-fns';
import { fromEvent, merge, Observable, Subject, Subscription, switchMap, take, takeUntil } from 'rxjs';
import { ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';

import {
  PointOfSaleType,
  LoyaltySettingsType,
  CorporateNotificationType,
  ListenForNewAdhocCorporateNotificationGQL,
  EventTypeEnum,
} from '@sifca-monorepo/widget-generator';
import { MobileThemeService } from '@sifca-monorepo/clients';

import { reputationPicture } from '../../environments/environment';
import { MobileAuthService, MobileNotificationsService, MobileReputationService } from '../../services';
@Component({
  template: '',
})
export class MobileNotificationComponent implements OnInit, OnDestroy {
  @ViewChild('preloader', { static: false }) preloaderEl!: ElementRef<HTMLElement>;

  private userInteracted = false;
  private interactionSub?: Subscription;
  private preloaderObserver?: IntersectionObserver;
  private unsubscribeAll: Subject<any> = new Subject<any>();

  currentUserId: string;
  isLoading: boolean = false;
  reputationPicture = reputationPicture;
  notifications: CorporateNotificationType[] = [];
  pos$: Observable<PointOfSaleType> = this.reputationService.pos$;
  loadingNotifications$ = this.notifService.loadingNotifications$;
  loyaltySettings$: Observable<LoyaltySettingsType> = this.reputationService.loyaltySettings$;

  private readonly titleMap = {
    REPUTATION_LOST: 'REPUTATION_LOST',
    REPUTATION_ALMOST_LOST: 'REPUTATION_ALMOST_LOST',
    REDEEM: 'REDEEM',
    TURNOVER_LOST: 'TURNOVER_LOST',
    TURNOVER_ALMOST_LOST: 'TURNOVER_ALMOST_LOST',
    PUSH_AMOUNT: 'PUSH_AMOUNT',
  } as const;

  private readonly descriptionMap = {
    REPUTATION_LOST: 'REPUTATION_LOST_DESCRIPTION',
    REPUTATION_ALMOST_LOST: 'REPUTATION_ALMOST_LOST_DESCRIPTION',
    TURNOVER_LOST: 'TURNOVER_LOST_DESCRIPTION',
    TURNOVER_ALMOST_LOST: 'TURNOVER_ALMOST_LOST_DESCRIPTION',
    PUSH_AMOUNT: 'SPECIAL_REWARD',
    REDEEM: 'REDEEM',
  } as const;

  private readonly betVariants = {
    won: [
      { title: 'BET_WON_TITLE_1', description: 'BET_WON_DESC_1' },
      { title: 'BET_WON_TITLE_2', description: 'BET_WON_DESC_2' },
      { title: 'BET_WON_TITLE_3', description: 'BET_WON_DESC_3' },
      { title: 'BET_WON_TITLE_4', description: 'BET_WON_DESC_4' },
      { title: 'BET_WON_TITLE_5', description: 'BET_WON_DESC_5' },
      { title: 'BET_WON_TITLE_6', description: 'BET_WON_DESC_6' },
      { title: 'BET_WON_TITLE_7', description: 'BET_WON_DESC_7' },
      { title: 'BET_WON_TITLE_8', description: 'BET_WON_DESC_8' },
    ],
    lost: [
      { title: 'BET_LOST_TITLE_1', description: 'BET_LOST_DESC_1' },
      { title: 'BET_LOST_TITLE_2', description: 'BET_LOST_DESC_2' },
      { title: 'BET_LOST_TITLE_3', description: 'BET_LOST_DESC_3' },
      { title: 'BET_LOST_TITLE_4', description: 'BET_LOST_DESC_4' },
      { title: 'BET_LOST_TITLE_5', description: 'BET_LOST_DESC_5' },
      { title: 'BET_LOST_TITLE_6', description: 'BET_LOST_DESC_6' },
      { title: 'BET_LOST_TITLE_7', description: 'BET_LOST_DESC_7' },
      { title: 'BET_LOST_TITLE_8', description: 'BET_LOST_DESC_8' },
    ],
  } as const;

  private readonly rewardVariants = {
    withCoupon: [
      { title: 'REWARD_WITH_COUPON_TITLE_1', description: 'REWARD_WITH_COUPON_DESC_1' },
      { title: 'REWARD_WITH_COUPON_TITLE_2', description: 'REWARD_WITH_COUPON_DESC_2' },
      { title: 'REWARD_WITH_COUPON_TITLE_3', description: 'REWARD_WITH_COUPON_DESC_3' },
      { title: 'REWARD_WITH_COUPON_TITLE_4', description: 'REWARD_WITH_COUPON_DESC_4' },
      { title: 'REWARD_WITH_COUPON_TITLE_5', description: 'REWARD_WITH_COUPON_DESC_5' },
      { title: 'REWARD_WITH_COUPON_TITLE_6', description: 'REWARD_WITH_COUPON_DESC_6' },
      { title: 'REWARD_WITH_COUPON_TITLE_7', description: 'REWARD_WITH_COUPON_DESC_7' },
      { title: 'REWARD_WITH_COUPON_TITLE_8', description: 'REWARD_WITH_COUPON_DESC_8' },
    ],
    withoutCoupon: [
      { title: 'REWARD_WITHOUT_COUPON_TITLE_1', description: 'REWARD_WITHOUT_COUPON_DESC_1' },
      { title: 'REWARD_WITHOUT_COUPON_TITLE_2', description: 'REWARD_WITHOUT_COUPON_DESC_2' },
      { title: 'REWARD_WITHOUT_COUPON_TITLE_3', description: 'REWARD_WITHOUT_COUPON_DESC_3' },
      { title: 'REWARD_WITHOUT_COUPON_TITLE_4', description: 'REWARD_WITHOUT_COUPON_DESC_4' },
      { title: 'REWARD_WITHOUT_COUPON_TITLE_5', description: 'REWARD_WITHOUT_COUPON_DESC_5' },
      { title: 'REWARD_WITHOUT_COUPON_TITLE_6', description: 'REWARD_WITHOUT_COUPON_DESC_6' },
      { title: 'REWARD_WITHOUT_COUPON_TITLE_7', description: 'REWARD_WITHOUT_COUPON_DESC_7' },
      { title: 'REWARD_WITHOUT_COUPON_TITLE_8', description: 'REWARD_WITHOUT_COUPON_DESC_8' },
      { title: 'REWARD_WITHOUT_COUPON_TITLE_9', description: 'REWARD_WITHOUT_COUPON_DESC_9' },
      { title: 'REWARD_WITHOUT_COUPON_TITLE_10', description: 'REWARD_WITHOUT_COUPON_DESC_10' },
    ],
  } as const;

  private readonly variantIndexByNotif = new Map();

  constructor(
    protected ngZone: NgZone,
    protected cd: ChangeDetectorRef,
    protected authService: MobileAuthService,
    protected themeService: MobileThemeService,
    protected reputationService: MobileReputationService,
    protected notifService: MobileNotificationsService,
    protected listenForNewAdhocCorporateNotificationGQL: ListenForNewAdhocCorporateNotificationGQL,
  ) {}

  ngOnInit(): void {
    this.notifications = [];
    this.notifService.pageIndex = 0;
    this.notifService.notifications$ = null;
    this.authService.currentUser$.pipe(takeUntil(this.unsubscribeAll)).subscribe((currentUser) => {
      this.currentUserId = currentUser?.id;
    });
    this.notifService
      .getCorporateNotificationsByUser()
      .pipe(
        switchMap(() => {
          return this.notifService.markAllCorporateNotificationsAsSeenForUser();
        }),
      )
      .subscribe();
    this.notifService.notifications$.pipe(takeUntil(this.unsubscribeAll)).subscribe((notifications) => {
      if (notifications?.length) {
        this.notifications.push(...this.reduceNotification(notifications));
        this.cd.markForCheck();
      }
    });
    const userId = this.currentUserId || localStorage.getItem('userId');
    if (userId) {
      this.listenForNewAdhocCorporateNotificationGQL
        .subscribe({ userId })
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe(({ data }) => {
          this.notifications = this.reduceNotification([...this.notifications, data.listenForNewAdhocCorporateNotification]);
        });
    }
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      const scroll$ = fromEvent(window, 'scroll');
      const wheel$ = fromEvent(window, 'wheel');
      const touch$ = fromEvent(window, 'touchstart');
      this.interactionSub = merge(scroll$, wheel$, touch$)
        .pipe(take(1))
        .subscribe(() => {
          this.userInteracted = true;
          this.setupTransactionsObserver();
        });
    });
  }

  trackNotification(index: number, notif: CorporateNotificationType): string | number {
    return notif?.id || index;
  }

  private setupTransactionsObserver(): void {
    if (!this.preloaderEl) {
      setTimeout(() => this.setupTransactionsObserver(), 150);
      return;
    }
    if (this.preloaderObserver) this.preloaderObserver.disconnect();

    const options: IntersectionObserverInit = {
      root: null,
      threshold: 0.1,
      rootMargin: '0px 0px 150px 0px',
    };
    this.preloaderObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && this.userInteracted && !this.isLoading) {
          this.ngZone.run(() => {
            this.notifService.isLastPage$.pipe(take(1)).subscribe((isLast) => {
              if (!isLast) {
                this.loadMoreQuests();
              } else {
                this.preloaderObserver?.disconnect();
              }
            });
          });
        }
      });
    }, options);
    this.preloaderObserver.observe(this.preloaderEl.nativeElement);
  }

  loadMoreQuests() {
    this.notifService.isLastPage$.pipe(take(1)).subscribe((isLast) => {
      if (!isLast) {
        this.isLoading = true;
        this.notifService.pageIndex += 1;
        this.notifService.getCorporateNotificationsByUser(false).subscribe(() => {
          this.isLoading = false;
          this.cd.markForCheck();
        });
      }
    });
  }

  getNotificationAvatar(notif: CorporateNotificationType): string | null {
    if (notif?.event === EventTypeEnum.ADHOC_NOTIFICATION) {
      const picture = notif?.action?.adhocNotification?.picture;
      if (picture?.baseUrl && picture?.path) {
        return `${picture.baseUrl}/${picture.path}`;
      }
    }

    return null;
  }

  getNotificationTitle(notif: CorporateNotificationType): string {
    if (notif?.event === EventTypeEnum.ADHOC_NOTIFICATION) {
      return notif?.action?.adhocNotification?.title || '';
    }
    if (notif?.event === 'REWARD') {
      return this.getRewardVariant(notif).title;
    }
    if (notif?.event === 'BET_WON' || notif?.event === 'BET_LOST') {
      return this.getBetVariant(notif).title;
    }
    return this.titleMap[notif?.event] || '';
  }

  getNotificationDescription(notif: CorporateNotificationType): string {
    if (notif?.event === EventTypeEnum.ADHOC_NOTIFICATION) {
      return notif?.action?.adhocNotification?.description || '';
    }

    if (notif?.event === 'REWARD') {
      return this.getRewardVariant(notif).description;
    }

    if (notif?.event === 'BET_WON' || notif?.event === 'BET_LOST') {
      return this.getBetVariant(notif).description;
    }

    return this.descriptionMap[notif?.event] || '';
  }

  getNotificationTranslationParams(notif: CorporateNotificationType) {
    const reward = notif?.action?.reward;
    const discountAmount = reward?.discount?.amount ?? '';
    const rewardTitle = reward?.title ?? '';

    return {
      rank: reward?.rank ?? '',
      game: reward?.game?.title ?? '',
      cycle: reward?.cycle ?? reward?.cycleNumber ?? '',
      rewardTitle,
      discountAmount,
      pos: rewardTitle,
      betSlip: reward?.betSlip ?? '',
      credit: reward?.credit ?? '',
    };
  }

  private getBetVariant(notif: CorporateNotificationType) {
    const variants = notif?.event === 'BET_WON' ? this.betVariants.won : this.betVariants.lost;
    const notifKey = `bet-${notif?.id || notif?.executedAt || 'bet'}-${notif?.event}`;
    const index = this.getVariantIndex(notifKey, variants.length);
    return variants[index];
  }

  private getRewardVariant(notif: CorporateNotificationType) {
    const reward = notif?.action?.reward;
    const hasCoupon = !!reward?.couponCode;
    const variants = hasCoupon ? this.rewardVariants.withCoupon : this.rewardVariants.withoutCoupon;
    const notifKey = `reward-${notif?.id || notif?.executedAt || 'reward'}-${hasCoupon ? 'coupon' : 'nocoupon'}`;
    const index = this.getVariantIndex(notifKey, variants.length);
    return variants[index];
  }

  private getVariantIndex(key, length) {
    const existing = this.variantIndexByNotif.get(key);
    if (existing !== undefined) {
      return existing;
    }
    const index = Math.floor(Math.random() * length);
    this.variantIndexByNotif.set(key, index);
    return index;
  }

  shouldShowReputationLoss(notif: CorporateNotificationType): boolean {
    return notif?.event === EventTypeEnum.REPUTATION_LOST && !!notif?.action?.reputationLoss;
  }

  getLossAmount(notif: CorporateNotificationType): number {
    return notif?.action?.reputationLoss || 0;
  }

  getNotificationIcon(notif: CorporateNotificationType): { name: string; colorClass: string } | null {
    const event = notif?.event;
    if (!event) {
      return null;
    }

    const iconMap: Record<string, { name: string; colorClass: string }> = {
      [EventTypeEnum.REPUTATION_LOST]: { name: 'minus_circle_fill', colorClass: 'color-red' },
      REPUTATION_ALMOST_LOST: { name: 'exclamationmark_circle_fill', colorClass: 'color-orange' },
      TURNOVER_LOST: { name: 'minus_circle_fill', colorClass: 'color-red' },
      TURNOVER_ALMOST_LOST: { name: 'exclamationmark_circle_fill', colorClass: 'color-orange' },
      REDEEM: { name: 'gift_fill', colorClass: 'color-green' },
      PUSH_AMOUNT: { name: 'star_fill', colorClass: 'color-yellow' },
      BET_WON: { name: 'trophy_fill', colorClass: 'color-green' },
      BET_LOST: { name: 'xmark_circle_fill', colorClass: 'color-red' },
      REWARD: { name: 'gift_fill', colorClass: 'color-primary' },
      [EventTypeEnum.ADHOC_NOTIFICATION]: { name: 'bell_fill', colorClass: 'color-primary' },
    };

    return iconMap[event] || { name: 'bell_fill', colorClass: 'color-primary' };
  }

  getQualitativeIcon(settings: LoyaltySettingsType | null | undefined): string {
    const picture = settings?.qualitative?.picture;
    if (picture?.baseUrl && picture?.path) {
      return `${picture.baseUrl}/${picture.path}`;
    }
    return this.reputationPicture;
  }

  reduceNotification(notifications) {
    const browserLang = localStorage.getItem('elvklang') || 'fr';
    return notifications.reduce((acc, notif) => {
      const notifDate = new Date(notif.executedAt);
      const dateDifference = formatDistanceToNow(notifDate, {
        addSuffix: true,
        locale:
          browserLang === 'ar-sa' || browserLang === 'ar' || browserLang === 'ar-tn'
            ? ar
            : browserLang === 'fr-fr' || browserLang === 'none'
              ? fr
              : browserLang === 'ar-tn'
                ? ar
                : browserLang === 'de'
                  ? de
                  : undefined,
      });
      acc.push({
        ...notif,
        /* event: 'BET_LOST', */
        dateDifference,
      });
      return acc;
    }, []);
  }

  ngOnDestroy() {
    this.notifications = [];
    this.notifService.pageIndex = 0;
    this.notifService.notifications$ = null;
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
    if (this.interactionSub) this.interactionSub.unsubscribe();
    if (this.preloaderObserver) this.preloaderObserver.disconnect();
  }
}
